const ROUTES = {
  LOGIN: process.env.PUBLIC_URL + "/",
  HOME: process.env.PUBLIC_URL + "/home",
  COLLECTIONS: process.env.PUBLIC_URL + "/list/:category/:subCategory",
  COLLECTIONSEMPTY: process.env.PUBLIC_URL + "/list/",
  DETAILS: process.env.PUBLIC_URL + "/details/:article",
  DETAILSEMPTY: process.env.PUBLIC_URL + "/details/",
  RESULTS: process.env.PUBLIC_URL + "/results",
  RESULTS_SEARCH: process.env.PUBLIC_URL + "/results/:search",
};

export default ROUTES;
